export const ELEMENT_SELECTOR = '[data-copy="disable"]';

document.querySelectorAll(ELEMENT_SELECTOR)
  .forEach(function (element) {
    element.oncopy = (ev) => ev.preventDefault();
    element.oncut = (ev) => ev.preventDefault();
  });
